import React from "react";

const Footer = () => {
    return (
        <footer id="footer">
            <div className="container">
                <h3>Delicious</h3>
                <p>
                    We don't care if we're doing haute cuisine or pastas and cookies.
                    We just do it right. Always.
                </p>
                <div className="social-links">
                    <a target="_blank" href="https://twitter.com" className="twitter">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a target="_blank" href="https://facebook.com" className="facebook">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <a target="_blank" href="https://instagram.com" className="instagram">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a target="_blank" href="https://linkedin.com" className="linkedin">
                        <i className="fab fa-linkedin-in"></i>
                    </a>
                </div>
                <div className="copyright">
                    &copy; Copyright{" "}
                    <strong>
                        <span>Delicious</span>
                    </strong>
                    . All Rights Reserved
                </div>
            </div>
        </footer>
    );
};

export default Footer;
